import { Codeowners } from '../../consts/codeowners';
import { captureException } from '../../utils/exception';
import { localStorage } from '../../utils/storage';

export const LOCAL_STORAGE_RWG_TOKEN_KEY = 'hcp_google_reserve_rwg_token';
export const GOOGLE_LEAD_SOURCE = 'google';

const getGoogleReserveTrackingURL = () => {
  return window.GOOGLE_RESERVE?.conversion_tracking_url;
};

const getGoogleReservePartnerId = () => {
  const partnerId = window.GOOGLE_RESERVE?.partner_id || '';

  return parseInt(partnerId, 10);
};

const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const rwgToken = urlParams.get('rwg_token');
  const leadSource = urlParams.get('lead_source');

  return { rwgToken, leadSource };
};

const getStoredReserveWithGoogleToken = () => {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_RWG_TOKEN_KEY) || '{}');
};

const deleteStoredReserveWithGoogleToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_RWG_TOKEN_KEY);
};

const getUnexpiredStoredReserveWithGoogleToken = () => {
  const storedToken = getStoredReserveWithGoogleToken();

  if (!storedToken?.value || !storedToken?.expiry) return null;

  const isExpired = Date.now() > storedToken.expiry;

  if (isExpired) {
    deleteStoredReserveWithGoogleToken();
    return null;
  }

  return storedToken.value;
};

export const getReserveWithGoogleToken = () => {
  const { rwgToken } = getUrlParams();

  return rwgToken || getUnexpiredStoredReserveWithGoogleToken();
};

export const isFromGoogle = () => {
  const { leadSource } = getUrlParams();
  return leadSource === GOOGLE_LEAD_SOURCE;
};

const trackGoogleReserveConversion = () => {
  const rwgToken = getReserveWithGoogleToken();
  const trackingUrl = getGoogleReserveTrackingURL();
  const isLeadSourceGoogle = isFromGoogle();

  if (!rwgToken?.length || !trackingUrl?.length || !isLeadSourceGoogle) return;

  return fetch(trackingUrl, {
    method: 'POST',
    body: JSON.stringify({
      conversion_partner_id: getGoogleReservePartnerId(),
      rwg_token: rwgToken,
      merchant_changed: 2,
    }),
  }).catch((error: unknown) => captureException(error, Codeowners.INNOVATION));
};

export default trackGoogleReserveConversion;
